import { GroupAuthority } from '@/models/back-office-pages/system'
import { AdministrationTypes } from '@/models/common'

export enum UserGroupSelect {
  BOARD = 'BOARD',
  BOARD2 = 'BOARD2',
  RISK1 = 'RISK1',
  RISK2 = 'RISK2',
  RISK3 = 'RISK3',
  SALES = 'SALES',
  SALES_ASSIGNEE = 'SALES_ASSIGNEE',
}

export interface AuthenticationInfoDTO {
  token: string
  refreshToken: string
  client: boolean
}

export interface LoginData {
  signInDummySA: AuthenticationInfoDTO
}

export enum GroupAuthorityNames {
  BOARD = 'Board (holding)',
  CREDIT_COMMITTEE = 'Credit committee',
  CREDIT_COMMITTEE_LEAD = 'Credit committee lead',
  RISK_LOCAL = 'Local risk committee',
  SALES_ALL = 'Head of sales',
  SALES_ASSIGNEE = 'Local Sales',
  OPERATIONS = 'Operations',
  OPERATIONS_LEAD = 'Operations lead',
  DEBT_COLLECTION_LEAD = 'Debt collection lead',
  DEBT_COLLECTION_OFFICER = 'Debt collection officer',
  UNKNOWN = 'Not assigned',
  HEAD_OF_RISK = 'Head of risk',
}

export enum BOUserRole {
  BOARD = 'board',
  OPERATIONS = 'operations',
  OPERATIONS_LEAD = 'operationsLead',
  RISK_LOCAL = 'riskLocal',
  RISK_LOCAL_LEAD = 'riskLocalLead',
  SALES = 'sales',
  SALES_LEAD = 'salesLead',
  ADMINISTRATOR = 'administrator',
  DC_LEAD = 'debtCollectorLead',
  DC_OFFICER = 'debtCollectorOfficer',
  HEAD_OF_RISK = 'headOfRisk',
  INVESTOR_MANAGER = 'investorManager',
}

export interface UserDetailsInfo {
  id?: string
  email: string
  firstName: string
  lastName: string
  groups: Array<GroupAuthority>
  board: boolean
  operations: boolean
  operationsLead: boolean
  riskLocal: boolean
  riskLocalLead: boolean
  headOfRisk: boolean
  sales: boolean
  salesLead: boolean
  administrator: boolean
  debtCollectorLead: boolean
  debtCollectorOfficer: boolean
  client: boolean
  investorManager: boolean
  companyCountryCode: string
  managedCountries: Array<string>
}

export interface CurrentUserInfoData {
  currentAccountSA: UserDetailsInfo
}

export interface ClientPortalContactUsDetailsDTO {
  operationsEmail: string
  operationsPhone: string
  salesManagerEmail: string
  salesManagerName: string
}

export interface ClientPortalContactUsDetailsData {
  contactUsInfoClientPortal: ClientPortalContactUsDetailsDTO
}

export interface ClientPortalClientPropertiesDTO {
  disableClientActions: boolean
  canCreateClientUser: boolean
  clientUsesGAmount: boolean
  enablePartialFactoring: boolean
  invoiceAttachmentRequired: boolean
  sourcingAgentCountry: string
  sourcingAgentAdministrates: AdministrationTypes
  hasLoanBookProducts: boolean
  peppolSendEnabled: boolean
}

export interface ClientPropertiesClientPortalData {
  clientPropertiesClientPortal: ClientPortalClientPropertiesDTO
}

export interface LoginSAData {
  signInSA: AuthenticationInfoDTO
}

export interface LoginSAVariables {
  password: string
  email: string
}

export interface EmailDTO {
  email: string
}

export interface ResetPasswordVariables {
  email: string
}

export interface ResetPasswordData {
  resetPasswordSA: EmailDTO
}

export interface ChangePasswordVariables {
  newPassword: string
  activationKey: string
}

export interface ChangePasswordData {
  changePassword: EmailDTO
}

export enum LoginFieldsNames {
  PASSWORD = 'password',
  EMAIL = 'email',
}

export enum ResetPasswordFieldsNames {
  EMAIL = 'email',
}

export enum ChangePasswordFieldsNames {
  NEW_PASSWORD = 'newPassword',
  CONFIRM_PASSWORD = 'confirmPassword',
}

export enum AppSections {
  FACTORING = 'FACTORING',
  RISK_MANAGEMENT = 'RISK_MANAGEMENT',
  ADMINISTRATION = 'ADMINISTRATION',
  PAYMENTS = 'PAYMENTS',
  LOAN_BOOK = 'LOAN_BOOK',
  INVESTMENT = 'INVESTMENT',
  // CLIENTS = 'CLIENTS',
}

export enum UserRole {
  BACK_OFFICE_USER = 'BACK_OFFICE_USER',
  CLIENT = 'CLIENT',
}

export enum ClientName {
  FAB = 'FAB',
  SFDI = 'SFDI',
  ROBOT = 'ROBOT',
}
